import React, { useState } from 'react'
import AccordionServicos from './accordionServicos'
import BadgetOtimize from './badget-otimize'
import CardServicos from './cardServicos'
import Container from './container'

export default function SegurancaCards({ title, cards = [] }) {
  const [openAccordionId, setOpenAccordionId] = useState(null)

  // Check if we have exactly 3 cards for special layout
  const hasExactlyThreeCards = cards.length === 3

  // Split cards into rows based on the number of cards
  const firstRowCards = hasExactlyThreeCards ? [] : cards.slice(0, 2) // First row has text + 2 cards when not 3 cards
  const secondRowCards = hasExactlyThreeCards ? cards : cards.slice(2) // All 3 cards in one row or remaining cards

  return (
    <div className="w-full bg-[#040116] pt-14 pb-16 lg:py-32 relative overflow-hidden">
      {/* Background com grafismos */}
      <div className="absolute inset-0 opacity-10">
        <img
          src="/assets/grafismos.svg"
          alt="Grafismos"
          className="w-full h-full object-cover"
        />
        <img
          src="/assets/grafismos.svg"
          alt="Grafismos"
          className="absolute inset-0 w-full h-full object-cover rotate-180"
        />
      </div>

      <Container className="hidden lg:block relative z-10">
        {/* Special layout for exactly 3 cards */}
        {cards.length === 3 ? (
          <>
            {/* Title centered above cards */}
            <div className="text-white flex justify-center mb-12">{title}</div>

            {/* All 3 cards in one row */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
              {cards.map((card, index) => (
                <div key={index} className="flex justify-center">
                  <CardServicos
                    icon={card.icon}
                    iconHover={card.iconHover || card.icon}
                    title={card.title}
                    text={card.text}
                    glowColor={card.glowColor || '#A002CB'}
                    url={card.url}
                    textSize="small"
                  />
                </div>
              ))}
            </div>
          </>
        ) : (
          <>
            {/* Standard layout for other card counts */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
              {/* Text Column */}
              <div className="text-white flex items-center justify-center h-full px-6">
                {title}
              </div>

              {/* First row cards */}
              {firstRowCards.map((card, index) => (
                <div key={index} className="flex justify-center">
                  <CardServicos
                    icon={card.icon}
                    iconHover={card.iconHover || card.icon}
                    title={card.title}
                    text={card.text}
                    glowColor={card.glowColor || '#A002CB'}
                    url={card.url}
                    textSize="small"
                  />
                </div>
              ))}
            </div>
          </>
        )}

        {/* Second row with remaining cards (only for non-3-card layouts) */}
        {cards.length !== 3 && secondRowCards.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {secondRowCards.map((card, index) => (
              <div key={index} className="flex justify-center">
                <CardServicos
                  icon={card.icon}
                  iconHover={card.iconHover || card.icon}
                  title={card.title}
                  text={card.text}
                  glowColor={card.glowColor || '#A002CB'}
                  url={card.url}
                  textSize="small"
                />
              </div>
            ))}
            {/* Add empty divs to maintain grid structure if row is not full */}
            {Array.from({ length: 3 - secondRowCards.length }).map((_, i) => (
              <div key={`empty-${i}`} />
            ))}
          </div>
        )}
      </Container>

      <Container className="hidden md:block lg:hidden relative z-10">
        <div className="text-white flex justify-center mb-12 text-center">
          {title}
        </div>

        <section className="grid grid-cols-2 gap-5">
          {cards.map((card, index) => (
            <div key={index} className="flex justify-center">
              <CardServicos
                icon={card.icon}
                iconHover={card.iconHover || card.icon}
                title={card.title}
                text={card.text}
                glowColor={card.glowColor || '#A002CB'}
                url={card.url}
                textSize="small"
              />
            </div>
          ))}
          {secondRowCards.map((card, index) => (
            <div key={index} className="flex justify-center">
              <CardServicos
                icon={card.icon}
                iconHover={card.iconHover || card.icon}
                title={card.title}
                text={card.text}
                glowColor={card.glowColor || '#A002CB'}
                url={card.url}
                textSize="small"
              />
            </div>
          ))}
        </section>

        {/* {cards.length !== 3 && secondRowCards.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {secondRowCards.map((card, index) => (
              <div key={index} className="flex justify-center">
                <CardServicos
                  icon={card.icon}
                  iconHover={card.iconHover || card.icon}
                  title={card.title}
                  text={card.text}
                  glowColor={card.glowColor || '#A002CB'}
                  url={card.url}
                  textSize="small"
                />
              </div>
            ))}
            {Array.from({ length: 3 - secondRowCards.length }).map((_, i) => (
              <div key={`empty-${i}`} />
            ))}
          </div>
        )} */}
      </Container>

      <Container className="md:hidden space-y-4">
        {cards.map((card, index) => (
          <div key={index} className="space-y-7">
            <button
              type="button"
              onClick={() =>
                setOpenAccordionId(openAccordionId === card.id ? null : card.id)
              }
              className="w-full"
            >
              <AccordionServicos
                {...card}
                className=""
                doesThereButton={false}
              />
            </button>
            {openAccordionId === card.id && <BadgetOtimize />}
          </div>
        ))}
      </Container>
    </div>
  )
}
